import './RagBuilder.css';
import { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import RagAppsTable from '../../components/Rag/RagAppsTable';
import RagIcon from '../../assets/img/ragAppIcon.svg';
import { Plus, Search } from 'lucide-react';
import { UnileverButton } from '../../components/ButtonComponents';
import { useNavigate } from 'react-router-dom';
import FilterForm from '../../components/SystemAnalytics/FilterForm';
import { getAdminList, getCompleteList, getList } from '../../service/ragApiServices';
import { useAzureData } from '../../context/AzureContext';
import UnileverAnimation from '../../components/UnileverAnimation';

const getDefaultDateRange = () => {
  const today = new Date();
  const pastDate = new Date();
  pastDate.setDate(today.getDate() - 7); // 7 days before today
  return { fromDate: pastDate, toDate: today };
};

// Extract numeric version: "v3" -> 3
function extractVersionNumber(version: any) {
  return Number(version.replace(/[^0-9]/g, '')) || 0;
}

const RagBuilder = () => {
  const navigate = useNavigate();
  const { apiToken, graphData } = useAzureData();
  const [search, setSearch] = useState('');
  const [show, setShow] = useState(false);
  //eslint-disable-next-line
  const [currentchooseApp, setCurrentChoosedApp] = useState<any>('');
  const { fromDate, toDate } = getDefaultDateRange();
  //eslint-disable-next-line
  const [dateRange, setDateRange] = useState({
    from: fromDate?.toLocaleDateString('en-GB'),
    to: toDate?.toLocaleDateString('en-GB')
  });
  const [ragData, setRagData] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  let loggedInUser = graphData?.mail;

  const fetchData = async () => {
    if (loggedInUser) {
      try {
        // Fetch admin list
        setLoading(true);
        const adminResponse = await getAdminList(apiToken);
        // @ts-ignore
        const isAdmin = adminResponse?.data?.data.some(
          (item) => item?.user_mail_id === loggedInUser
        );

        // Fetch appropriate data based on admin status
        let response;
        if (isAdmin) {
          response = await getCompleteList(apiToken);
        } else {
          response = await getList(apiToken, loggedInUser);
        }

        // @ts-ignore
        if (response?.data?.data && response?.data?.data?.length > 0) {
          // setRagData(response.data.data);

          // @ts-ignore
          const raw = response?.data?.data || [];
          // GROUPING (rag_app_name is unique per group)
          const groupedData = Object.values(
            raw.reduce((acc: any, item: any) => {
              const name = item.rag_app_name;

              if (!acc[name]) {
                acc[name] = {
                  rag_app_name: name,
                  versions: []
                };
              }

              // Push the item AS-IS (no key changes)
              acc[name].versions.push({ ...item });

              return acc;
            }, {})
          );

          // SORTING (latest version first)
          groupedData?.forEach((group: any) => {
            group.versions.sort((a: any, b: any) => {
              const verA = extractVersionNumber(a.version);
              const verB = extractVersionNumber(b.version);

              // sort by version number
              if (verB !== verA) return verB - verA;

              // if same version, sort by created date (latest first)
              // @ts-ignore
              return new Date(b.created_date_time) - new Date(a.created_date_time);
            });
          });

          // SORT groups by newest created app
          groupedData.sort((a: any, b: any) => {
            return (
              new Date(b.versions[0].created_date_time).getTime() -
              new Date(a.versions[0].created_date_time).getTime()
            );
          });

          setRagData(groupedData);

          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    //eslint-disable-next-line
  }, [loggedInUser]);

  // const filteredTableData = !search ? ragData : ragData?.filter((row: any) => {
  //     const searchTerm = search.toLowerCase();

  //     return (
  //         row.rag_app_name?.toLowerCase().includes(searchTerm) ||
  //         row.servicename?.toLowerCase().includes(searchTerm) ||
  //         row.rag_app_status?.toLowerCase().includes(searchTerm) ||
  //         row.created_by?.toLowerCase().includes(searchTerm)
  //     );
  // });

  // let applicationNames = filterDropdownValues && filterDropdownValues?.filters?.applications?.length > 0 && filterDropdownValues?.filters?.applications?.map((item) => ({ label: item, value: item }))
  let businessGroup = [
    { label: 'App-001', value: '21642eee' },
    { label: 'SPN-002', value: 'SPN-002' },
    { label: 'SPN-003', value: 'SPN-003' },
    { label: 'SPN-004', value: 'SPN-004' }
  ];
  let embeddingModel = [
    { label: 'App-001', value: '21642eee' },
    { label: 'SPN-002', value: 'SPN-002' },
    { label: 'SPN-003', value: 'SPN-003' },
    { label: 'SPN-004', value: 'SPN-004' }
  ];
  let vectorDatabseProvider = [
    { label: 'App-001', value: '21642eee' },
    { label: 'SPN-002', value: 'SPN-002' },
    { label: 'SPN-003', value: 'SPN-003' },
    { label: 'SPN-004', value: 'SPN-004' }
  ];

  return (
    <main>
      <Container fluid className="pt-4">
        <Row className="align-items-center mb-2">
          <Col>
            <h5 className="mb-1 rag_header">
              <span>
                <img src={RagIcon} alt="icon" />
              </span>
              My RAG Apps
            </h5>
            <div className="rag_subheader">
              Help new users get started smoothly with guided steps, essential information, and
              quick access to key features.
            </div>
          </Col>
          <Col xs="12" md="6" lg="5" className="mt-3 mt-md-0">
            <div className="d-flex gap-2 justify-content-md-end">
              <div className="search-box d-flex align-items-center">
                <Search size={18} strokeWidth={1.5} color="#838FB4" />
                <input
                  type="text"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              {/* <Button onClick={() => setShow(true)} variant="outline-secondary" className="d-flex align-items-center gap-2 filterBtn fs-7" style={{ height: '34px', color: "#111111" }}>
                                <img src={filterIcon} alt='filter' />
                                Filter
                            </Button> */}
              <UnileverButton
                styleClass={{ height: '34px' }}
                buttonAction={() => navigate('/newragform')}>
                <Plus size={16} /> New RAG
              </UnileverButton>
            </div>
          </Col>
        </Row>

        {loading ? (
          <div className="d-flex justify-content-center" style={{ marginTop: '10%' }}>
            {/* <Spinner animation="border" variant="primary" /> */}
            <UnileverAnimation />
          </div>
        ) : (
          <RagAppsTable
            searchTerm={search}
            // initialGroups={groupedData}
            initialGroups={ragData}
            setRagData={setRagData}
            fetchData={fetchData}
            headers={[
              { key: 'version', label: 'Version' },
              { key: 'rag_app_name', label: 'RAG-App-Name', sortable: true },
              { key: 'rag_app_status', label: 'Status' },
              { key: 'is_active', label: 'Active Status' },
              { key: 'created_date_time', label: 'Created at', sortable: true },
              {
                key: 'data_last_refreshed_date_time',
                label: 'Last Data Refreshed at',
                sortable: true
              }
            ]}
          />
        )}

        <FilterForm
          show={show}
          onClose={() => {
            setShow(false);
            // setShowOnlyTimePeriodFilter(false)
          }}
          onApply={(filters) => {
            // fetchData(filters)
            // setChoosedFilter(filters)
          }}
          onDateRangeChange={setDateRange}
          onCurrentChoosedAppChange={setCurrentChoosedApp}
          fields={[
            { key: 'timePeriod', label: 'Time Period', type: 'dateRange' },
            {
              key: 'businessGroup',
              label: 'Business Group',
              type: 'select',
              options: businessGroup ? businessGroup : []
            },
            {
              key: 'embeddingModel',
              label: 'Embedding Model',
              type: 'select',
              options: embeddingModel ? embeddingModel : []
            },
            {
              key: 'vectorDatabseProvider',
              label: 'Vector Databse Provider',
              type: 'select',
              options: vectorDatabseProvider ? vectorDatabseProvider : []
            }
          ]}
        />
      </Container>
    </main>
  );
};

export default RagBuilder;
